exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-nellemann {\n    background-color: black;\n}\n\n.btn-nellemann:disabled {\n    opacity: 1;\n}\n\n.spinner {\n    margin: auto;\n\n    border: 4px solid rgba(0, 0, 0, 0.1);\n    border-left: 4px solid RGB(88,160,94);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/landingpages/prolongings/dealerpage/dealerpage.component.css
// module id = 1026
// module chunks = 23